export const NotificationType = {
  1: 'Bilgi',
  2: 'Uyarı',
  3: 'Önemli',
}
